module.exports = __webpack_public_path__ + "img/cover-minigame-bg.7cb39155.jpg";